module.exports = __webpack_public_path__ + "static/img/samajuri (26).0258fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (26).jpg
// module id = 0LUq
// module chunks = 0